module.exports = __webpack_public_path__ + "static/media/Edit-Polygon.3c2dd618.svg";